<template>
	<!-- This example requires Tailwind CSS v2.0+ -->
	<div
		:class="{
			'rounded-md border border-green-200 bg-green-50 p-4': type == 'success',
			'rounded-md border border-red-200 bg-red-50 p-4': type == 'error',
		}"
	>
		<div class="flex items-center">
			<ui-icon
				class="flex-shrink-0"
				:name="
					type == 'success'
						? 'check-circle'
						: type == 'error'
						? 'alert-triangle'
						: ''
				"
				:class="{
					'h-5 w-5 text-green-500': type == 'success',
					'h-5 w-5 text-red-600': type == 'error',
				}"
				stroke-width="2"
			/>
			<div class="ml-3">
				<span
					:class="{
						'text-sm font-medium text-green-500': type == 'success',
						'text-sm font-medium text-red-600': type == 'error',
					}"
				>
					{{ __(message) }}
					<ul v-if="bulletPoints" role="list" class="list-disc pl-5 space-y-1">
						<li v-for="(message, idx) in bulletPoints" :key="idx">
							{{ message }}
						</li>
					</ul>
				</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		message: {
			type: String,
			required: true,
		},
		bulletPoints: {
			type: Array,
			required: false,
		},
		type: {
			type: String,
			default: "success", // success, error, danger
		},
	},
};
</script>
